import React from 'react';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';

const EmployeeDocumentBreadcrumbItem = ({ filePath = '' }: { filePath?: string }) => {
  const fileName = filePath?.split('/')?.pop() || 'Document';
  return <SingleBreadcrumbItem entity={fileName} />;
};

export default EmployeeDocumentBreadcrumbItem;
